import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Table, Select } from "antd";
// NAVIGATION
import { useLocation } from "react-router-dom";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import useGetAllBanksLight from "../../../customHooks/GET_requests/useGetAllBanksLight";
// INTERFACES
import { FormularyHeaderInputSelectBankInterface } from "../../../interfaces/Global.interface";
import { BankLightInterface } from "../../../interfaces/Bank.interface";
import { formatUuidT } from "../../../flatbuffers/display";

export default function FormularyHeaderInputSelectBank({
  formAction,
  value,
  onChangeFormValueText,
  variableName,
  itemId,
  onClickCellName = () => {},
  enabledCellClick = false,
  disableCreateRow = false,
}: FormularyHeaderInputSelectBankInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Column, ColumnGroup } = Table;
  const { Option, OptGroup } = Select;
  const [t] = useTranslation("global");
  const location = useLocation();
  const idBank = new URLSearchParams(location.search).get("idBank");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [serverGroups, setServerGroups] = useState<[{ id: ""; name: "" }]>([{ id: "", name: "" }]);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { banksLight, isLoadingGetAllBanksLight } = useGetAllBanksLight();

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getItemName = (recordId: string) => {
    const item = banksLight.find((v: any) => v.id === recordId);
    return item ? item.name : "--";
  };

  const uniqueServers = () => {
    const newGroups: any = [];
    banksLight.map((item: BankLightInterface) => {
      if (
        item &&
        item.channel &&
        item.channel.server &&
        item.channel.server.id &&
        item.channel.server.name
      ) {
        newGroups.push({
          name: item.channel.server.name,
          id: item.channel.server.id,
        });
      }
      return true;
    });
    // Sort by name
    newGroups.sort((a: any, b: any) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    // Remove repeat items
    const uniqueArray = newGroups.filter(
      (item: any, index: any, self: any) =>
        index === self.findIndex((obj: any) => obj.id === item.id),
    );
    //
    setServerGroups(uniqueArray);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    if (banksLight && banksLight.length > 0) {
      uniqueServers();
    }
  }, [banksLight]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <ColumnGroup title={t("general.bank")}>
      <Column
        className="generalStyles__hoverCursor"
        onCell={(record: any) => ({
          onClick: () => {
            if (enabledCellClick && (disableCreateRow || formAction === "create")) {
              onClickCellName(record);
            }
          },
        })}
        title={
          disableCreateRow ? (
            t("general.bank")
          ) : (
            <Select
              className="generalStyles__width100"
              showSearch
              disabled={formAction === "edit" || (idBank !== null && idBank !== "")}
              optionFilterProp="children"
              placeholder={t("report.selectBank")}
              value={formAction === "create" ? value : ""}
              size="small"
              onChange={(e: any) => {
                onChangeFormValueText(e, variableName);
              }}
              loading={isLoadingGetAllBanksLight}
            >
              {serverGroups.map((serv: any) => (
                <OptGroup key={serv.id} label={`SERVER / ${serv.name}`}>
                  {banksLight
                    .filter(
                      (bank: BankLightInterface) =>
                        bank && bank.channel.server && bank.channel.server.id === serv.id,
                    )
                    .map((server: { id: string; name: string }) => (
                      <Option key={formatUuidT(server.id)} value={formatUuidT(server.id)}>
                        {server.name}
                      </Option>
                    ))}
                </OptGroup>
              ))}
            </Select>
          )
        }
        dataIndex={variableName}
        key={variableName}
        render={(text, record: any) => (
          <div>
            {formAction === "edit" && record.id === itemId ? (
              <Select
                className="generalStyles__width100"
                showSearch
                optionFilterProp="children"
                placeholder={t("report.selectBank")}
                value={value}
                size="small"
                onChange={(e: any) => {
                  onChangeFormValueText(e, variableName);
                }}
                loading={isLoadingGetAllBanksLight}
                disabled
              >
                {serverGroups.map((serv: any) => (
                  <OptGroup key={serv.id} label={`SERVER / ${serv.name}`}>
                    {banksLight
                      .filter(
                        (bank: BankLightInterface) =>
                          bank && bank.channel.server && bank.channel.server.id === serv.id,
                      )
                      .map((server: { id: string; name: string }) => (
                        <Option key={formatUuidT(server.id)} value={formatUuidT(server.id)}>
                          {server.name}
                        </Option>
                      ))}
                  </OptGroup>
                ))}
              </Select>
            ) : (
              <div>{getItemName(text)}</div>
            )}
          </div>
        )}
      />
    </ColumnGroup>
  );
}
